import { useSelector } from "react-redux";
import { RootState } from "../store";
import { AuthInfo } from "../store/appSlice";

export const useAuth = (): AuthInfo|undefined => {
  return useSelector((state: RootState) => state.app.auth);
}